// extracted by css-extract-rspack-plugin
export default {"title":"_3752e349","body":"_545e9019","icon":"_77a3f242","error":"_1a37d111"};